import escapeRegExp from 'lodash/escapeRegExp';

const passwordSpecialCharacters = String.raw`!@#$%^&*()_+{}[]:;<>,.?/~\`"'\\|=`;
const escapedSpecialCharacters = escapeRegExp(passwordSpecialCharacters);
const passwordRegExp = new RegExp(
  `^(?=.*[A-Za-z])(?=.*\\d)(?=.*[${escapedSpecialCharacters}])[A-Za-z\\d${escapedSpecialCharacters}]{8,16}$`
);

/** 영문, 숫자, 특수문자를 포함한 8~16자인지 검증한다. */
export function isValidPassword(password: string): boolean {
  return passwordRegExp.test(password);
}
